import { Box, Stack } from '@mui/joy'
import { useStore, useStoreMap } from 'effector-react'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { carRentalModel } from '~/entities/common/Organizations/CarRental'
import { usePermissions } from '~/entities/common/viewer'
import {
  EditCarRental,
  editCarRentalModel,
} from '~/features/russia/Organization/CarRentals/EditCarRentals'
import { Breadcrumbs, BreadcrumbsList } from '~/shared/ui/Breadcrumbs'
import { Container, PageContainer, PageTitle } from '~/shared/ui/Layout'
import { NotFound } from '~/shared/ui/NotFound'
import {
  QuickNavigation,
  QuickNavigationOptions,
} from '~/shared/ui/QuickNavigation'
import { AuditsModal } from '~/widgets/common/AuditsModal'

const quickNavigationOptions: QuickNavigationOptions = [
  { labelI18n: 'requisites', anchor: 'requisites' },
  { labelI18n: 'management', anchor: 'management' },
  { labelI18n: 'contacts', anchor: 'contacts' },
  { labelI18n: 'bank', anchor: 'bank' },
]

export function EditCarRentalPageRussia() {
  const { t } = useTranslation()

  const { carRentalId } = useParams<{ carRentalId: string }>()

  const { canAuditsView } = usePermissions()

  const isLoading = useStore(carRentalModel.requestFx.pending)
  const name = useStoreMap(editCarRentalModel.$carRental, (carRental) =>
    carRental?.getName(),
  )

  const breadcrumbs: BreadcrumbsList = useMemo(
    () => [
      { titleI18n: 'organizations', link: '/organizations/car-rentals' },
      { titleI18n: 'lessors', link: '/organizations/car-rentals' },
      { title: name || '' },
    ],
    [name],
  )

  const error = carRentalModel.useCarRentalError(carRentalId as string)

  if (!carRentalId || error) {
    return <NotFound message={t('alert.failed to load lessor')} />
  }

  return (
    <PageContainer title={t('lessor card')}>
      <Container isHeader>
        <Stack direction='row' alignItems='end' justifyContent='space-between'>
          <Box>
            <Breadcrumbs list={breadcrumbs} lastLoading={isLoading} />
            <PageTitle loading={isLoading}>{name}</PageTitle>
          </Box>
          {canAuditsView && <AuditsModal auditableId={carRentalId} />}
        </Stack>
      </Container>

      <EditCarRental carRentalId={carRentalId} />

      <QuickNavigation options={quickNavigationOptions} />
    </PageContainer>
  )
}
